/* Program pages built from the owner's master specifications
   (KDX_FUTURE_*_Master_Spec, 7 October 2026), rendered by
   src/pages/programs/ProgramSpecPage.jsx. Add a program here when its
   spec arrives; the thinner template (ProgramPage.jsx, programPages.js)
   covers the programs still waiting for theirs. */

import { BUSINESS_AI } from "./businessAI";
import { FINANCE } from "./finance";

export const PROGRAM_SPECS = {
  "business-ai": BUSINESS_AI,
  "finance-accounting": FINANCE,
};

export const PROGRAM_SPEC_SLUGS = Object.keys(PROGRAM_SPECS);
